// import { useState, useEffect, useRef } from 'react';
// import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
// import axios from 'axios';
// import { useAuth } from '../../../context/AuthContext';
// import ClientMaster from '../../ClientMaster';
// import LeadSourceMaster from './LeadSourceMaster';
// import ActivityMaster from './ActivityMaster';
// import CurrencyMaster from '../../CurrencyMaster';
// import LeadStatusMaster from './LeadStatusMaster';
// import UserMaster from '../../UserMaster';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import { useTheme, useMediaQuery } from '@mui/material';
// import { toProperCase } from '../../../utils/formatRows';

// const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

// export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false }) {
//     const { user, selectedCompany, loading } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     const clientInit = initialData.client || initialData || {};
//     const API = connectionString;
//     const partyDropdownRef = useRef(null);

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//     // ─── client search state ─────────────────────────────────────────────
//     const [qoutId, setQoutId] = useState(clientInit.qoutId ?? null);
//     const [companyName, setCompanyName] = useState(clientInit.companyName || clientInit.FirmName || '');
//     const [selectedClientId, setSelectedClientId] = useState(clientInit.clientId || null);
//     const [searchResults, setSearchResults] = useState([]);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [clientError, setClientError] = useState(false);


//     // ─── other form state ────────────────────────────────────────────────
//     const [details, setDetails] = useState(clientInit.details || []);
//     const [error, setError] = useState('');
//     const [quotationNumber, setquotationNumber] = useState(clientInit.quotationNumber || '');
//     const [qoutationDate, setqoutationDate] = useState(() => {
//         // For add OR ref mode, default to today
//         if (mode === 'add' || mode === 'ref') return dayjs();

//         // Otherwise try to parse clientInit value (if present)
//         if (clientInit.qoutationDate && dayjs(clientInit.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
//             return dayjs(clientInit.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']);
//         }

//         return null;
//     });
//     const [referenceNumber, setReferenceNumber] = useState(clientInit.referenceNumber || '');
//     const [referenceDate, setReferenceDate] = useState(null); // Default to null for 'add' and 'ref' modes
//     const [exchangeRate, setExchangeRate] = useState(clientInit.exchangeRate || '');
//     const [kindAttend, setKindAttend] = useState(clientInit.kindAttend || '');
//     const [project, setProject] = useState(clientInit.project || '');
//     const [agentName, setAgentName] = useState(clientInit.agentName || clientInit.AgentName || '');
//     const [agentCommission, setAgentCommission] = useState(clientInit.AgentComm ?? clientInit.agentCommission ?? '');
//     const [remark, setRemark] = useState(clientInit.remark || clientInit.remarks || '');


//     // ─── masters & popups ────────────────────────────────────────────────
//     const [currencyOptions, setCurrencyOptions] = useState([]);
//     const [selectedCurrency, setSelectedCurrency] = useState(null);
//     const [openClientPopup, setOpenClientPopup] = useState(false);
//     const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
//     const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
//     const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
//     const [openActivityPopup, setOpenActivityPopup] = useState(false);
//     const [openStatusPopup, setOpenStatusPopup] = useState(false);

//     const [transactionType, setTransactionType] = useState(clientInit.transactionType || '')
//     const isTransactionTypeValid = Boolean(transactionType);
//     const [touchedTxnType, setTouchedTxnType] = useState(false);
//     const [selectedGSTNum, setSelectedGSTNum] = useState("")


//     console.log("searchResults****", searchResults)

//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "success"
//     });

//     const requiredAsteriskStyle = {
//         '& .MuiFormLabel-asterisk': {
//             color: 'red',
//         },
//     };

//     const handlePopupClose = (data) => {
//         if (data?.success) {
//             setSnackbar({
//                 open: true,
//                 message: data.message,
//                 severity: "success"
//             });
//         }
//     };


//     useEffect(() => {
//         console.log("selectedGSTnum", selectedGSTNum)
//         //  Do not override if user manually changed
//         if (touchedTxnType) return;

//         //  Do not override edit mode existing value
//         if (mode === "edit" && clientInit.transactionType) return;

//         // GST not evaluated yet
//         if (selectedGSTNum === "") return;

//         if (selectedGSTNum) {
//             setTransactionType("regular");
//         } else {
//             setTransactionType("unregisteredPersons");
//         }

//     }, [selectedGSTNum, touchedTxnType, mode, clientInit.transactionType]);


//     // ─── load auto-generated inquiry number ───────────────────────────────
//     useEffect(() => {
//         console.log('useEffect(fetchReceiptNo) run, mode =', mode);
//         if (mode === 'edit') return;
//         fetchReceiptNo('Q');
//     }, [mode]);

//     async function fetchReceiptNo(code) {
//         try {
//             console.log('fetchReceiptNo called, code=', code);
//             const res = await axios.get(`${API}/api/get-challNo`, { params: { companyId, code } });
//             console.log('Raw response from /api/get-challNo:', res);
//             const payload = res?.data ?? {};
//             const payloadInner = payload?.data ?? payload;
//             const challanNumber =
//                 payloadInner?.challanNumber ??
//                 payloadInner?.challanNo ??
//                 payload?.challanNumber ??
//                 payload?.challanNo ??
//                 '';
//             console.log('Derived challanNumber:', challanNumber);
//             if (challanNumber) {
//                 setquotationNumber(String(challanNumber));
//             } else {
//                 console.warn('fetchReceiptNo: no challanNumber in response, payloadInner:', payloadInner);
//                 setquotationNumber('');
//             }
//         } catch (err) {
//             console.error('Error fetching challan number:', err);
//             setquotationNumber('');
//         }
//     }

//     // ─── load all master-lists and initialize selectedCurrency ────────────
//     useEffect(() => {
//         const fetchMasters = async () => {
//             try {
//                 const [cur] = await Promise.all([axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`)]);
//                 const options = transform(cur.data || [], 'CurrencyId', 'CurrencySymbol');
//                 setCurrencyOptions(options);
//                 const currencyId =
//                     clientInit.currencyId ??
//                     clientInit.CurrencyId ??
//                     null;

//                 if (currencyId) {
//                     const foundCurrency = options.find(
//                         opt => opt.id === Number(currencyId)
//                     );
//                     setSelectedCurrency(foundCurrency || null);
//                 }

//             } catch (err) {
//                 console.error('Error fetching masters:', err);
//                 setCurrencyOptions([]);
//                 setSelectedCurrency(null);
//             }
//         };
//         fetchMasters();
//     }, [clientInit]);

//     // ─── initialize from clientInit ─────────────────────────────────────
//     useEffect(() => {
//         console.log('Initializing ClientDetails with clientInit:', clientInit);
//         if (!clientInit || Object.keys(clientInit).length === 0) {
//             // Modified: Explicitly set today's date for 'add' mode when clientInit is empty
//             if (mode === 'add') {
//                 setqoutationDate(dayjs());
//             }
//             return;
//         }

//         setQoutId(clientInit.qoutId ?? null);
//         setCompanyName(clientInit.companyName || clientInit.FirmName || '');
//         setSelectedClientId(clientInit.clientId ?? null);
//         setSelectedGSTNum(
//             clientInit?.gstNumber ||
//             clientInit?.GSTNo ||
//             clientInit?.details?.["GST No."]
//         );

//     if (clientInit.details) {
//         if (Array.isArray(clientInit.details)) {
//             setDetails(clientInit.details);
//         } else if (typeof clientInit.details === 'object') {
//             const arr = Object.entries(clientInit.details).map(([label, value]) => ({ label, value }));
//             setDetails(arr);
//         }
//     } else {
//         const c = {
//             city: clientInit.city || '',
//             state: clientInit.state || '',
//             mobileNo: clientInit.mobileNo || '',
//             emailId: clientInit.emailId || '',
//             contactPerson: clientInit.contactPerson || '',
//             gstNumber: clientInit.gstNumber || ''
//         };
//         setDetails([
//             { label: 'City', value: c.city },
//             { label: 'State', value: c.state },
//             { label: 'mobileNo', value: c.mobileNo },
//             { label: 'Email', value: c.emailId },
//             { label: 'ContactPerson', value: c.contactPerson },
//             { label: 'GST No.', value: c.gstNumber }
//         ]);
//     }

//     setquotationNumber(clientInit.quotationNumber || (mode !== 'edit' ? quotationNumber : ''));
//     // Modified: Explicitly set today's date for 'add' mode, preserve other modes
//     if (mode === 'add' || mode === 'ref') {
//         // Always show today's date for add OR ref modes
//         setqoutationDate(dayjs());

//     } else {
//         setqoutationDate(
//             clientInit.qoutationDate && dayjs(clientInit.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//                 ? dayjs(clientInit.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
//                 : clientInit.nextFollowUpDate && dayjs(clientInit.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//                     ? dayjs(clientInit.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
//                     : null
//         );
//     }

//     setReferenceNumber(clientInit.referenceNumber || '');
//     setReferenceDate(
//         clientInit.referenceDate && dayjs(clientInit.referenceDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//             ? dayjs(clientInit.referenceDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
//             : clientInit.inquiryDate && dayjs(clientInit.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//                 ? dayjs(clientInit.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
//                 : null
//     );
//     setExchangeRate(clientInit.exchangeRate || '');
//     setKindAttend(clientInit.kindAttend || '');
//     setProject(clientInit.project || '');
//     setAgentName(clientInit.agentName || clientInit.AgentName || '');
//     setAgentCommission(clientInit.AgentComm ?? clientInit.agentCommission ?? '');
//     setRemark(clientInit.remark || clientInit.remarks || '');
//     setTransactionType(
//         clientInit.transactionType || ""
//     );
// }, [clientInit, mode, quotationNumber]);

// // ─── fetch search results ─────────────────────────────────────────────
// useEffect(() => {
//     if (!companyName || !dropdownOpen) {
//         setSearchResults([]);
//         return;
//     }

//     const fetch = async () => {
//         try {
//             const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
//             const data = Array.isArray(res.data.data) ? res.data.data : [];
//             console.log('Company search results:', data);
//             setSearchResults(data);
//         } catch (err) {
//             console.error('Error fetching company search results:', err);
//             setSearchResults([]);
//         }
//     };
//     fetch();
// }, [companyName, dropdownOpen]);

// // ─── Handle row selection in table ────────────────────────────────────
// const onSelectResult = r => {
//     setSelectedClientId(r.id);
//     setSelectedGSTNum(r.GSTNo);
//     setTouchedTxnType(false);
//     setCompanyName(r.FirmName || r.companyName || '');
//     setAgentName(r.AgentName || '');
//     setAgentCommission(r.AgentComm || '');

//     const c = {
//         City: r.City || '',
//         state: r.state || '',
//         MobileNo: r.MobileNo || '',
//         EmailId: r.EmailId || '',
//         ContactPerson: r.ContactPerson || '',
//         GSTNo: r.GSTNo || ''
//     };
//     setDetails([
//         { label: 'City', value: c.City },
//         { label: 'State', value: c.state },
//         { label: 'mobileNo', value: c.MobileNo },
//         { label: 'Email', value: c.EmailId },
//         { label: 'ContactPerson', value: c.ContactPerson },
//         { label: 'GST No.', value: c.GSTNo }
//     ]);
//     setDropdownOpen(false);
//     setClientError(false);
// };

// // ─── dropdownField for Autocomplete ───────────────────────────────────
// const dropdownField = (label, options, value, setValue) => (
//     <Grid item xs={12} sm={8} md={12}>
//         <Autocomplete
//             fullWidth
//             options={options}
//             getOptionLabel={opt => opt?.label || ''}
//             value={value}
//             onChange={(_, v) => setValue(v)}
//             isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
//             disabled={!isEditable}
//             renderInput={params => (
//                 <TextField
//                     {...params}
//                     label={label}
//                     size="small"
//                     InputLabelProps={{ shrink: Boolean(value) }}
//                     sx={{
//                         '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                         '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                     }}
//                 />
//             )}
//         />
//     </Grid>
// );

// // ─── Next button ─────────────────────────────────────────────────────
// const handleNext = () => {
//     if (!companyName || !quotationNumber) {
//         setError('Party & Inquiry No. are required.');
//         return;
//     }
//     if (!selectedClientId) {
//         setClientError(true);
//         return;
//     }
//     setError('');

//     const payload = {
//         clientId: selectedClientId,
//         companyName,
//         quotationNumber,
//         SODate: qoutationDate ? qoutationDate.format('YYYY-MM-DD') : null,
//         referenceNumber,
//         referenceDate: referenceDate && referenceDate.isValid() ? referenceDate.format('YYYY-MM-DD') : null,
//         CurrencyId: selectedCurrency?.id || null,
//         exchangeRate: exchangeRate ? Number(exchangeRate) : null,
//         kindAttend: kindAttend || null,
//         remarks: remark || null,
//         project: project || null,
//         agentName: agentName || null,
//         agentCommission: agentCommission ? Number(agentCommission) : null,
//         details: details.reduce((acc, curr) => {
//             acc[curr.label] = curr.value;
//             return acc;
//         }, {}),
//         qoutId,
//         transactionType
//     };
//     console.log('ClientDetails onNext payload:', payload);
//     onNext(payload);
// };

// // allow editing only in 'add', 'edit', or 'ref' modes
// const isEditable = mode === 'add' || mode === 'edit' || mode === 'ref';

// return (
//     <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden' }}>
//         <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
//             <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>
//                 {/* Party dropdown */}
//                 <Box
//                     ref={partyDropdownRef}
//                     tabIndex={-1}
//                     sx={{ position: 'relative', flex: '1 1 40%' }}
//                     onBlur={e => {
//                         if (!partyDropdownRef.current.contains(e.relatedTarget)) {
//                             setDropdownOpen(false);
//                         }
//                     }}
//                 >
//                     <TextField
//                         disabled={!isEditable || disablePartyName}
//                         fullWidth
//                         size="small"
//                         label="Party Name"
//                         error={clientError}
//                         variant="outlined"
//                         value={toProperCase(companyName)}
//                         required
//                         InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }}
//                         sx={{
//                             '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' },
//                             '& .MuiOutlinedInput-input': { padding: '0 12px' }
//                         }}
//                         onChange={e => {
//                             setCompanyName(toProperCase(e.target.value));
//                             setDropdownOpen(true);
//                             setSelectedClientId(null);
//                             setClientError(false);
//                         }}
//                         onBlur={() => {
//                             if (companyName && !selectedClientId) {
//                                 setClientError(true);
//                             }
//                         }}
//                         helperText={
//                             clientError ? "Client does not exist. Please add new client or select from the List" : ""
//                         }
//                     />
//                     {/* {dropdownOpen && (
//                             <TableContainer
//                                 component={Paper}
//                                 elevation={0}
//                                 sx={{ mt: 1, maxHeight: 240, position: 'absolute', width: '120%', zIndex: 10, border: 'none', overflow: 'auto', border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1 }}
//                             >
//                                 <Table
//                                     size="small"
//                                     sx={{
//                                         borderCollapse: 'separate',
//                                         borderSpacing: 0,
//                                         tableLayout: 'fixed',              // force cells to obey widths
//                                         '& thead th': {
//                                             backgroundColor: '#1877F2',
//                                             color: '#fff',
//                                             fontWeight: 600,
//                                             fontSize: '0.75rem',
//                                             border: 'none'
//                                         },
//                                         '& th, & td': {                    // reduce padding between columns
//                                             padding: '4px 6px',              // smaller vertical & horizontal padding
//                                             fontSize: '0.75rem',
//                                             overflow: 'hidden',
//                                             textOverflow: 'ellipsis',
//                                             whiteSpace: 'nowrap',
//                                         },
//                                         // option: collapse borders so there is no extra gap
//                                         '& .MuiTableCell-root': {
//                                             borderRight: '0px'               // remove right cell border if any
//                                         }
//                                     }}
//                                 >
//                                     <TableHead>
//                                         <TableRow>
//                                             <TableCell sx={{ width: '30%', maxWidth: 200 }}>Company</TableCell>
//                                             <TableCell sx={{ width: '15%', maxWidth: 120 }}>GST No</TableCell>
//                                             <TableCell sx={{ width: '20%', maxWidth: 140 }}>Contact</TableCell>
//                                             <TableCell sx={{ width: '20%', maxWidth: 120 }}>Mobile</TableCell>
//                                             <TableCell sx={{ width: '15%', maxWidth: 100 }}>City</TableCell>
//                                         </TableRow>
//                                     </TableHead>
//                                     <TableBody sx={{ '& > tr:last-of-type': { borderBottom: '1px solid rgba(0,0,0,0.12)' } }}>
//                                         {searchResults.length > 0 ? (
//                                             searchResults.map((r, i) => (
//                                                 <TableRow
//                                                     key={i}
//                                                     hover
//                                                     onMouseDown={() => onSelectResult(r)}
//                                                     sx={{ cursor: 'pointer', backgroundColor: i % 2 === 0 ? '#fff' : 'rgba(227, 242, 253, 1)', border: 'none' }}
//                                                 >
//                                                     <TableCell sx={{ width: '30%', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.FirmName}</TableCell>
//                                                     <TableCell sx={{ width: '15%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.GSTNo}</TableCell>
//                                                     <TableCell sx={{ width: '20%', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.ContactPerson}</TableCell>
//                                                     <TableCell sx={{ width: '20%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.MobileNo}</TableCell>
//                                                     <TableCell sx={{ width: '15%', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.City}</TableCell>
//                                                 </TableRow>
//                                             ))
//                                         ) : (
//                                             <TableRow>
//                                                 <TableCell colSpan={5} align="center">No Data Available</TableCell>
//                                             </TableRow>
//                                         )}
//                                     </TableBody>
//                                     <TableFooter sx={{ borderTop: '1px solid rgba(0,0,0,0.12)' }}>
//                                         <TableRow
//                                             hover
//                                             sx={{ cursor: 'pointer', backgroundColor: '#fff' }}
//                                             onMouseDown={() => setOpenClientPopup(true)}
//                                         >
//                                             <TableCell colSpan={5} sx={{ textAlign: 'center', color: 'primary.main' }}>
//                                                 ➕ Add New Client
//                                             </TableCell>
//                                         </TableRow>
//                                     </TableFooter>
//                                 </Table>
//                             </TableContainer>
//                         )} */}
//                     {dropdownOpen && companyName && (
//                         <Paper
//                             elevation={0}
//                             sx={{
//                                 mt: 1,
//                                 position: 'absolute',
//                                 width: { xs: '100%', lg: '800px' },
//                                 zIndex: 10,
//                                 border: '1px solid rgba(0,0,0,0.2)',
//                                 borderRadius: 1,
//                                 maxHeight: 240,
//                                 overflowY: 'auto'
//                             }}
//                         >
//                             {isSmallScreen ? (
//                                 /* ===================== CARD VIEW (SM / XS) ===================== */
//                                 <>
//                                     {searchResults.length > 0 ? (
//                                         searchResults.map((r, i) => (
//                                             <Box
//                                                 key={i}
//                                                 sx={{
//                                                     p: 1.2,
//                                                     borderBottom: '1px solid #eee',
//                                                     cursor: 'pointer'
//                                                 }}
//                                                 onMouseDown={() => {
//                                                     onSelectResult(r);
//                                                     // setSelectedClientId(r.ClientId);
//                                                     // setSelectedGSTNum(r.GSTNo);
//                                                     setCompanyName(toProperCase(r.FirmName));
//                                                     setClientError(false);
//                                                     setDropdownOpen(false);
//                                                 }}
//                                             >
//                                                 <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
//                                                     {toProperCase(r.FirmName)}
//                                                 </Box>

//                                                 <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                                                     GST: {r.GSTNo || '-'}
//                                                 </Box>

//                                                 <Box sx={{ fontSize: '0.75rem' }}>
//                                                     {toProperCase(r.ContactPerson) || '-'} • {r.MobileNo || '-'}
//                                                 </Box>

//                                                 <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                                                     {toProperCase(r.City) || '-'}
//                                                 </Box>
//                                             </Box>
//                                         ))
//                                     ) : (
//                                         <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
//                                             Client not found
//                                         </Box>
//                                     )}

//                                     {/* Sticky Add New Client */}
//                                     <Box
//                                         sx={{
//                                             position: 'sticky',
//                                             bottom: 0,
//                                             backgroundColor: '#fff',
//                                             textAlign: 'center',
//                                             p: 1,
//                                             fontWeight: 600,
//                                             color: 'primary.main',
//                                             cursor: 'pointer',
//                                             boxShadow: '0 -2px 6px rgba(0,0,0,0.08)'
//                                         }}
//                                         onMouseDown={() => setOpenClientPopup(true)}
//                                     >
//                                         ➕ Add New Client
//                                     </Box>
//                                 </>
//                             ) : (
//                                 /* ===================== TABLE VIEW (MD / LG) ===================== */
//                                 <Table size="small" stickyHeader>
//                                     <TableHead>
//                                         <TableRow>
//                                             {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
//                                                 <TableCell
//                                                     key={h}
//                                                     sx={{
//                                                         backgroundColor: '#E0E0E0',
//                                                         fontWeight: 600,
//                                                         fontSize: '0.75rem',
//                                                         position: 'sticky',
//                                                         top: 0,
//                                                         zIndex: 1
//                                                     }}
//                                                 >
//                                                     {h}
//                                                 </TableCell>
//                                             ))}
//                                         </TableRow>
//                                     </TableHead>

//                                     <TableBody>
//                                         {searchResults.length > 0 ? (
//                                             searchResults.map((r, i) => (
//                                                 <TableRow
//                                                     key={i}
//                                                     hover
//                                                     sx={{ cursor: 'pointer' }}
//                                                     onMouseDown={() => {
//                                                         onSelectResult(r);
//                                                         setCompanyName(toProperCase(r.FirmName));
//                                                         // setSelectedGSTNum(r.GSTNo);
//                                                         setClientError(false);
//                                                         setDropdownOpen(false);
//                                                     }}
//                                                 >
//                                                     <TableCell>{toProperCase(r.FirmName)}</TableCell>
//                                                     <TableCell>{r.GSTNo}</TableCell>
//                                                     <TableCell>{toProperCase(r.ContactPerson)}</TableCell>
//                                                     <TableCell>{r.MobileNo}</TableCell>
//                                                     <TableCell>{toProperCase(r.City)}</TableCell>
//                                                 </TableRow>
//                                             ))
//                                         ) : (
//                                             <TableRow>
//                                                 <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
//                                                     Client not found
//                                                 </TableCell>
//                                             </TableRow>
//                                         )}
//                                     </TableBody>

//                                     <TableFooter
//                                         sx={{
//                                             position: 'sticky',
//                                             bottom: 0,
//                                             backgroundColor: '#fff'
//                                         }}
//                                     >
//                                         <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
//                                             <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
//                                                 ➕ Add New Client
//                                             </TableCell>
//                                         </TableRow>
//                                     </TableFooter>
//                                 </Table>
//                             )}
//                         </Paper>
//                     )}
//                 </Box>

//                 {/* Details display */}
//                 <Grid item xs={12} md={4} pt={2}>
//                     <TextField
//                         fullWidth
//                         size="small"
//                         label="Address"
//                         variant="outlined"
//                         disabled
//                         value={
//                             Array.isArray(details)
//                                 ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', '))
//                                 : ''
//                         }
//                         multiline
//                         rows={3}
//                         InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }}
//                         sx={{
//                             '& .MuiOutlinedInput-root': { display: 'flex', alignItems: 'center' },
//                             '& .MuiOutlinedInput-input': { padding: '0 12px' }
//                         }}
//                     />
//                 </Grid>

//                 {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Kind Attend"
//                                 value={kindAttend}
//                                 onChange={e => setKindAttend(e.target.value)}
//                                 InputLabelProps={{ shrink: Boolean(kindAttend) }}
//                                 disabled={!isEditable}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                 }}
//                             />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Project"
//                                 value={project}
//                                 onChange={e => setProject(e.target.value)}
//                                 InputLabelProps={{ shrink: Boolean(project) }}
//                                 disabled={!isEditable}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                 }}
//                             />
//                         </Box>
//                     </Box> */}

//                 <Box sx={{ mt: 2 }}>
//                     <TextField
//                         fullWidth
//                         size="small"
//                         label="Remark"
//                         disabled={!isEditable}
//                         multiline
//                         minRows={1}
//                         maxRows={6}
//                         value={remark}
//                         InputLabelProps={{ shrink: Boolean(remark) }}
//                         inputProps={{ maxLength: 250 }}
//                         onChange={(e) => {
//                             const val = e.target.value;
//                             if (val.length <= 250) setRemark(val);
//                             else setRemark(val.slice(0, 250));
//                         }}
//                         sx={{
//                             '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' }
//                         }}
//                     />
//                     <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
//                         {remark.length}/250
//                     </Typography>
//                 </Box>
//             </Box>

//             <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
//                 <Box display="flex" gap={2} flex="1 1 40%">
//                     <Box sx={{ flex: '0 0 48%' }}>
//                         <TextField
//                             fullWidth
//                             size="small"
//                             label="Challan No."
//                             variant="outlined"
//                             value={quotationNumber}
//                             disabled
//                             InputLabelProps={{ shrink: true }}
//                             sx={{
//                                 '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' },
//                                 '& .MuiOutlinedInput-input': { padding: '0 12px' }
//                             }}
//                         />
//                     </Box>

//                     <Box sx={{ flex: '0 0 48%' }}>
//                         <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                             <DatePicker
//                                 label="Challan Date"
//                                 value={qoutationDate}
//                                 onChange={setqoutationDate}
//                                 format="DD/MM/YYYY"
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },

//                                 }}
//                                 slotProps={{
//                                     textField: {
//                                         size: "small",
//                                         variant: "outlined",
//                                         InputLabelProps: { shrink: true },

//                                     },
//                                 }}
//                             />
//                         </LocalizationProvider>
//                     </Box>
//                 </Box>

//                 <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                     {/* <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 variant="outlined"
//                                 label="Ref. No."
//                                 value={referenceNumber}
//                                 onChange={e => setReferenceNumber(e.target.value)}
//                                 InputLabelProps={{ shrink: Boolean(referenceNumber) }}
//                                 disabled={!isEditable}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
//                                 }}
//                             />
//                         </Box> */}

//                     {/* <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker
//                                     label="Ref. Date"
//                                     value={referenceDate}
//                                     onChange={(newValue) => setReferenceDate(newValue)}
//                                     disabled={!isEditable}
//                                     format="DD/MM/YYYY"
//                                     sx={{
//                                         '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                         '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
//                                     }}
//                                     slotProps={{
//                                         textField: {
//                                             size: "small",
//                                             variant: "outlined",
//                                             InputLabelProps: { shrink: Boolean(referenceDate) },

//                                         },
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box> */}
//                 </Box>

//                 <Box display="flex" gap={2} flex="1 1 40%" flexDirection={{ xs: 'column', md: 'row' }}>
//                     <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
//                         <Box sx={{ flex: '0 0 50%' }}>
//                             {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)}
//                         </Box>
//                         <Box sx={{ flex: '0 0 47%' }}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 type="number"
//                                 variant="outlined"
//                                 label="Ex Rate"
//                                 value={exchangeRate}
//                                 InputLabelProps={{ shrink: Boolean(exchangeRate) }}
//                                 disabled={!isEditable}
//                                 onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (/^\d*\.?\d{0,2}$/.test(value)) {
//                                         setExchangeRate(value);
//                                     }
//                                 }}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
//                                 }}
//                             />
//                         </Box>
//                     </Box>

//                     <Box sx={{ flex: '0 0 48%' }}>
//                         <FormControl fullWidth size="small" required sx={{
//                             '& .MuiFormLabel-asterisk': {
//                                 color: 'red',
//                             },
//                         }} error={touchedTxnType && !transactionType} >
//                             <InputLabel>Transaction Type</InputLabel>
//                             <Select
//                                 value={transactionType}
//                                 label="Transaction Type"
//                                 onChange={(e) => {
//                                     setTransactionType(e.target.value);
//                                     setTouchedTxnType(true);
//                                 }}
//                                 onBlur={() => setTouchedTxnType(true)}
//                                 sx={{ height: 38 }}
//                                 required
//                             >
//                                 <MenuItem value="regular">Regular</MenuItem>
//                                 <MenuItem value="unregisteredPersons">Unregistered Persons</MenuItem>
//                                 <MenuItem value="sezExempted">SEZ Exempted</MenuItem>
//                                 <MenuItem value="sezTaxPay">SEZ Tax Pay</MenuItem>
//                                 <MenuItem value="exportWithTaxPay">Export With Tax Pay</MenuItem>
//                                 <MenuItem value="exportWithoutTaxPay">Export Without Tax Pay</MenuItem>
//                                 <MenuItem value="exemptedSupplies">Exempted Supplies</MenuItem>
//                                 <MenuItem value="nilRateSupplies">Nil Rate Supplies</MenuItem>
//                                 <MenuItem value="nonGSTSupplies">Non GST Supplies</MenuItem>
//                                 <MenuItem value="compositeSupplier">Composite Supplier</MenuItem>
//                                 <MenuItem value="uinholders">UIN holders</MenuItem>
//                                 <MenuItem value="zeroRatedSupplies">Zero Rated Supplies</MenuItem>
//                             </Select>
//                         </FormControl>

//                     </Box>
//                 </Box>

//                 <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                     <Box sx={{ flex: '0 0 48%' }}>
//                         <TextField
//                             fullWidth
//                             label="Agent Name"
//                             value={toProperCase(agentName)}
//                             onChange={e => setAgentName(e.target.value)}
//                             InputLabelProps={{ shrink: Boolean(agentName) }}
//                             variant="outlined"
//                             size="small"
//                             disabled={!isEditable}
//                             sx={{
//                                 '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                 '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
//                             }}
//                         />
//                     </Box>

//                     <Box sx={{ flex: '0 0 48%' }}>
//                         <TextField
//                             fullWidth
//                             label="Agent Commission (%)"
//                             value={agentCommission}
//                             InputLabelProps={{ shrink: Boolean(agentCommission) }}
//                             variant="outlined"
//                             size="small"
//                             type="number"
//                             disabled={!isEditable}
//                             onChange={e => {
//                                 const v = e.target.value;
//                                 if (v === '') {
//                                     setAgentCommission('');
//                                     return;
//                                 }
//                                 const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
//                                 if (re.test(v)) {
//                                     setAgentCommission(v);
//                                 }
//                             }}
//                             sx={{
//                                 '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                 '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
//                             }}
//                         />
//                     </Box>
//                 </Box>
//             </Box>
//         </Box>

//         {!!error && (<Typography color="error" mt={2}> {error} </Typography>)}

//         <Box mt={4} display="flex" justifyContent="flex-end">
//             <Button variant="contained" onClick={handleNext} disabled={!selectedClientId || !isTransactionTypeValid}>Next</Button>
//         </Box>

//         {/* Popups */}
//         <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
//             if (reason === 'backdropClick') return;
//             setOpenClientPopup(false);
//         }}>
//             <DialogContent>
//                 <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
//             </DialogContent>
//         </Dialog>
//         <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
//             <DialogContent>
//                 <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
//             </DialogContent>
//         </Dialog>
//         <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
//             <DialogContent>
//                 <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
//             </DialogContent>
//         </Dialog>
//         <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
//             <DialogContent>
//                 <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
//             </DialogContent>
//         </Dialog>
//         <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
//             <DialogContent>
//                 <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
//             </DialogContent>
//         </Dialog>
//         <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
//             <DialogContent>
//                 <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
//             </DialogContent>
//         </Dialog>

//         <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//             <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
//                 {snackbar.message}
//             </Alert>
//         </Snackbar>
//     </Paper>
// );
// }




import { colors as themeColors } from '../../../utils/theme';
import { useState, useEffect, useRef } from 'react';
import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import { useConfigure } from '../../../context/ConfigureContext';
import ClientMaster from '../../ClientMaster';
import LeadSourceMaster from './LeadSourceMaster';
import ActivityMaster from './ActivityMaster';
import CurrencyMaster from '../../CurrencyMaster';
import LeadStatusMaster from './LeadStatusMaster';
import UserMaster from '../../UserMaster';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useTheme, useMediaQuery } from '@mui/material';
import { toProperCase } from '../../../utils/formatRows';
import { getFinancialYearBounds } from '../../../utils/financialYear';

const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false }) {
    const { user, selectedCompany, loading } = useAuth();
    const { isFeatureEnabled } = useConfigure();
    const showCurrency = isFeatureEnabled('Show Currency?');
    const companyId = selectedCompany?.CompId || null;
    const clientInit = initialData.client || initialData || {};
    const API = connectionString;
    const partyDropdownRef = useRef(null);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // ─── client search state ─────────────────────────────────────────────
    const [qoutId, setQoutId] = useState(clientInit.qoutId ?? null);
    const [companyName, setCompanyName] = useState(clientInit.companyName || clientInit.FirmName || '');
    const [selectedClientId, setSelectedClientId] = useState(clientInit.clientId || null);
    const [searchResults, setSearchResults] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [clientError, setClientError] = useState(false);


    // ─── other form state ────────────────────────────────────────────────
    const [details, setDetails] = useState(clientInit.details || []);
    const [error, setError] = useState('');
    const [quotationNumber, setquotationNumber] = useState(clientInit.quotationNumber || '');
    const { startDate, endDate } = getFinancialYearBounds();
    const [qoutationDate, setqoutationDate] = useState(() => {
        // For add OR ref mode, default to today
        if (mode === 'add' || mode === 'ref') return dayjs();

        // Otherwise try to parse clientInit value (if present)
        if (clientInit.qoutationDate && dayjs(clientInit.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            return dayjs(clientInit.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']);
        }

        return null;
    });
    const [referenceNumber, setReferenceNumber] = useState(clientInit.referenceNumber || '');
    const [referenceDate, setReferenceDate] = useState(null); // Default to null for 'add' and 'ref' modes
    const [exchangeRate, setExchangeRate] = useState(clientInit.exchangeRate || '');
    const [kindAttend, setKindAttend] = useState(clientInit.kindAttend || '');
    const [project, setProject] = useState(clientInit.project || '');
    const [agentName, setAgentName] = useState(clientInit.agentName || clientInit.AgentName || '');
    const [agentCommission, setAgentCommission] = useState(clientInit.AgentComm ?? clientInit.agentCommission ?? '');
    const [remark, setRemark] = useState(clientInit.remark || clientInit.remarks || '');


    // ─── masters & popups ────────────────────────────────────────────────
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [openClientPopup, setOpenClientPopup] = useState(false);
    const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
    const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
    const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
    const [openActivityPopup, setOpenActivityPopup] = useState(false);
    const [openStatusPopup, setOpenStatusPopup] = useState(false);

    const [transactionType, setTransactionType] = useState(clientInit.transactionType || '')
    const isTransactionTypeValid = Boolean(transactionType);
    const [touchedTxnType, setTouchedTxnType] = useState(false);
    const [selectedGSTNum, setSelectedGSTNum] = useState("")
    const [seriesOptions, setSeriesOptions] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState(initialData.selectedSeries || null);
    const [seriesError, setSeriesError] = useState(false);
    const [BookName, setBookName] = useState('Sale Challan - Sale Invoice');

    const [hasClientChanged, setHasClientChanged] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);


    const [poNumber, setPoNumber] = useState(clientInit.poNumber || clientInit.PONo || '');
    const [poDate, setPoDate] = useState(
        clientInit.poDate &&
            dayjs(clientInit.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
            ? dayjs(clientInit.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
            : null
    );

    console.log("searchResults****", searchResults)

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const [termsOptions, setTermsOptions] = useState([]);
    const [selectedTerms, setSelectedTerms] = useState(initialData.selectedTerms || null);
    const [termsInputValue, setTermsInputValue] = useState('');


    const fetchLastTerms = async () => {
        try {
            const res = await axios.get(`${API}/api/last-terms-type`, {
                params: {
                    mode: 'SaleChallan',
                    companyId
                }
            });

            const termsValue = res?.data?.TermsType;

            console.log("modeee", mode)

            // Only for add/ref mode
            if (
                termsValue &&
                (mode === 'add')
            ) {
                setSelectedTerms({
                    label: String(termsValue)
                });
            }

        } catch (err) {
            console.error("Error fetching last terms", err);
        }
    };


    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const { data: response } = await axios.get(`${API}/api/termscondition/search`, {
                    params: { companyId, mode: 'search' },
                    validateStatus: (status) => status >= 200 && status < 400,
                });
                const data = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
                console.log(data)
                const options = data.map(item => ({
                    label: item.TermsType || item.TermsName || ''
                }));
                setTermsOptions(options);
            } catch (err) {
                console.error('Error fetching terms:', err);
                setTermsOptions([]);
            }
        };

        if (companyId) {
            fetchTerms();
            fetchLastTerms();
        }


    }, [companyId]);

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const handlePopupClose = (data) => {
        if (data?.success) {
            setSnackbar({
                open: true,
                message: data.message,
                severity: "success"
            });
        }
    };


    useEffect(() => {
        if (
            (mode === "edit" || mode === "ref") &&
            !isInitialized &&
            clientInit?.transactionType   //  wait for real data
        ) {
            setTransactionType(clientInit.transactionType);
            setIsInitialized(true);
        }
    }, [clientInit, mode, isInitialized]);

    // useEffect(() => {
    //     //  do nothing if no client selected
    //     if (!selectedClientId) return;

    //     // edit mode control
    //     if ((mode === "edit" || mode === "ref") && !hasClientChanged) return;

    //     // manual override
    //     if (touchedTxnType) return;

    //     // GST not ready
    //     if (selectedGSTNum === "") return;

    //     const newType = selectedGSTNum
    //         ? "regular"
    //         : "unregisteredPersons";

    //     setTransactionType(newType);

    // }, [selectedGSTNum, selectedClientId, touchedTxnType, hasClientChanged, mode]);

    useEffect(() => {
        // do nothing if no client selected
        if (!selectedClientId) return;

        // manual override - user has manually selected
        if (touchedTxnType) return;

        // GST not ready
        if (selectedGSTNum === "") return;

        // ✅ FIX: Different logic for edit vs ref mode
        if (mode === "edit") {
            // In edit mode, only auto-set if client has changed
            if (!hasClientChanged) return;
        } else if (mode === "ref") {
            // In ref mode, allow auto-set on initial load OR when client changes
            // Do nothing extra here - let it proceed to set transaction type
        }

        const newType = selectedGSTNum ? "Regular" : "Unregistered Persons";
        setTransactionType(newType);

    }, [selectedGSTNum, selectedClientId, touchedTxnType, hasClientChanged, mode]);

    useEffect(() => {
        const fetchSeries = async () => {
            try {
                const { data } = await axios.get(`${API}/api/bookmaster-series`, {
                    params: { companyId, bookTypeName: 'Sale Challan - Sale Invoice' } // IMPORTANT
                });

                const seriesOpts = transform(data, 'BookMastID', 'SeriesName');
                setSeriesOptions(seriesOpts);
            } catch (err) {
                console.error('Error fetching series:', err);
            }
        };

        if (companyId) fetchSeries();
    }, [companyId]);

    useEffect(() => {
        const fetchDefaultSeries = async () => {
            try {
                const { data: response } = await axios.get(`${API}/api/series/getSeries`, {
                    params: {
                        companyId,
                        mode: 'search',
                        bookName: 'Sale Challan - Sale Invoice'   // ✅ ADD THIS
                    }
                });

                const data = response?.data || response || [];

                const defaultSeries = data.find(item => item.IsDefault == 1);

                const isAddOrProforma = mode?.toLowerCase() === 'add' || mode?.toLowerCase() === 'ref';

                console.log("Default Series Data:", data);

                if (defaultSeries && isAddOrProforma && !selectedSeries) {
                    setSelectedSeries({
                        id: defaultSeries.BookMastID,
                        label: defaultSeries.SeriesName
                    });
                }

            } catch (err) {
                console.error("Default Series Error:", err);
            }
        };

        if (companyId && (mode?.toLowerCase() === 'add' || mode?.toLowerCase() === 'ref')) {
            fetchDefaultSeries();
        }
    }, [companyId, mode]);

    useEffect(() => {
        if (!selectedSeries || mode === 'edit') return;

        const generateNumber = async () => {
            try {
                const { data } = await axios.get(`${API}/api/generate-challan-series-number`, {
                    params: { companyId, bookMastId: selectedSeries.id }
                });

                setquotationNumber(data.challanNumber);
            } catch (err) {
                console.error('Error generating challan number:', err);
            }
        };

        generateNumber();
    }, [selectedSeries, mode]);

    // useEffect(() => {
    //     // ✅ Do NOT auto-change if user selected manually
    //     if (touchedTxnType) return;

    //     // ✅ Do NOT override if already set (IMPORTANT FIX)
    //     if (transactionType) return;

    //     // ✅ Protect edit + ref mode
    //     if ((mode === "edit" || mode === "ref") && initialData.transactionType) return;

    //     // ✅ GST not ready
    //     if (selectedGSTNum === "") return;

    //     if (selectedGSTNum) {
    //         setTransactionType("regular");
    //     } else {
    //         setTransactionType("unregisteredPersons");
    //     }

    // }, [selectedGSTNum, touchedTxnType, mode, initialData.transactionType]);

    // ─── load all master-lists and initialize selectedCurrency ────────────
    useEffect(() => {
        const fetchMasters = async () => {
            try {
                const [cur] = await Promise.all([axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`)]);
                const options = transform(cur.data || [], 'CurrencyId', 'CurrencySymbol');
                setCurrencyOptions(options);
                const currencyId =
                    clientInit.currencyId ??
                    clientInit.CurrencyId ??
                    null;

                if (currencyId) {
                    const foundCurrency = options.find(
                        opt => opt.id === Number(currencyId)
                    );
                    setSelectedCurrency(foundCurrency || null);
                }

            } catch (err) {
                console.error('Error fetching masters:', err);
                setCurrencyOptions([]);
                setSelectedCurrency(null);
            }
        };
        fetchMasters();
    }, [clientInit]);

    // ─── initialize from clientInit ─────────────────────────────────────
    useEffect(() => {
        console.log('Initializing ClientDetails with clientInit:', clientInit);
        if (!clientInit || Object.keys(clientInit).length === 0) {
            // Modified: Explicitly set today's date for 'add' mode when clientInit is empty
            if (mode === 'add') {
                setqoutationDate(dayjs());
            }
            return;
        }

        setQoutId(clientInit.qoutId ?? null);
        setCompanyName(clientInit.companyName || clientInit.FirmName || '');
        setSelectedClientId(clientInit.clientId ?? null);
        setSelectedGSTNum(
            clientInit?.gstNumber ||
            clientInit?.GSTNo ||
            clientInit?.details?.["GST No."]
        );

        if (mode === 'edit') {
            setSelectedTerms(
                initialData.TermsType
                    ? {
                        id: initialData.TermsType,
                        label: String(initialData.TermsType)
                    }
                    : null
            );
        }


        if (clientInit.details) {
            if (Array.isArray(clientInit.details)) {
                setDetails(clientInit.details);
            } else if (typeof clientInit.details === 'object') {
                const arr = Object.entries(clientInit.details).map(([label, value]) => ({ label, value }));
                setDetails(arr);
            }
        } else {
            const c = {
                city: clientInit.city || '',
                state: clientInit.state || '',
                mobileNo: clientInit.mobileNo || '',
                emailId: clientInit.emailId || '',
                contactPerson: clientInit.contactPerson || '',
                gstNumber: clientInit.gstNumber || ''
            };
            setDetails([
                { label: 'City', value: c.city },
                { label: 'State', value: c.state },
                { label: 'mobileNo', value: c.mobileNo },
                { label: 'Email', value: c.emailId },
                { label: 'ContactPerson', value: c.contactPerson },
                { label: 'GST No.', value: c.gstNumber }
            ]);
        }

        setquotationNumber(clientInit.quotationNumber || (mode !== 'edit' ? quotationNumber : ''));
        // Modified: Explicitly set today's date for 'add' mode, preserve other modes
        if (mode === 'add' || mode === 'ref') {
            // Always show today's date for add OR ref modes
            setqoutationDate(dayjs());

        } else {
            setqoutationDate(
                clientInit.qoutationDate && dayjs(clientInit.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                    ? dayjs(clientInit.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                    : clientInit.nextFollowUpDate && dayjs(clientInit.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                        ? dayjs(clientInit.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                        : null
            );
        }

        setReferenceNumber(clientInit.referenceNumber || '');
        setReferenceDate(
            clientInit.referenceDate && dayjs(clientInit.referenceDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                ? dayjs(clientInit.referenceDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                : clientInit.inquiryDate && dayjs(clientInit.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                    ? dayjs(clientInit.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                    : null
        );
        setExchangeRate(clientInit.exchangeRate || '');
        setKindAttend(clientInit.kindAttend || '');
        setProject(clientInit.project || '');
        setAgentName(clientInit.agentName || clientInit.AgentName || '');
        setAgentCommission(clientInit.AgentComm ?? clientInit.agentCommission ?? '');
        setRemark(clientInit.remark || clientInit.remarks || '');

        setPoNumber(clientInit.poNumber || clientInit.PONo || '');

        setPoDate(
            clientInit.poDate &&
                dayjs(clientInit.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                ? dayjs(clientInit.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                : null
        );
        // setTransactionType(
        //     clientInit.transactionType || ""
        // );
    }, [clientInit, mode]);

    // ─── fetch search results ─────────────────────────────────────────────
    // Debounced 350ms so a fast typist doesn't fire one API call per keystroke —
    // the search still starts automatically as the user types, just waits for a
    // brief pause before actually calling the API.
    useEffect(() => {
        if (!companyName || !dropdownOpen) {
            setSearchResults([]);
            return;
        }

        const timeoutId = setTimeout(() => {
            const fetch = async () => {
                try {
                    const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
                    const data = Array.isArray(res.data.data) ? res.data.data : [];
                    console.log('Company search results:', data);
                    setSearchResults(data);
                    setHighlightedIndex(0);
                } catch (err) {
                    console.error('Error fetching company search results:', err);
                    setSearchResults([]);
                }
            };
            fetch();
        }, 350);

        return () => clearTimeout(timeoutId);
    }, [companyName, dropdownOpen]);

    // ─── Handle row selection in table ────────────────────────────────────
    const onSelectResult = r => {
        setSelectedClientId(r.id);
        setSelectedGSTNum(r.GSTNo);
        setHasClientChanged(true);
        setTouchedTxnType(false);
        setCompanyName(r.FirmName || r.companyName || '');
        setAgentName(r.AgentName || '');
        setAgentCommission(r.AgentComm || '');

        const c = {
            City: r.City || '',
            state: r.state || '',
            MobileNo: r.MobileNo || '',
            EmailId: r.EmailId || '',
            ContactPerson: r.ContactPerson || '',
            GSTNo: r.GSTNo || ''
        };
        setDetails([
            { label: 'City', value: c.City },
            { label: 'State', value: c.state },
            { label: 'mobileNo', value: c.MobileNo },
            { label: 'Email', value: c.EmailId },
            { label: 'ContactPerson', value: c.ContactPerson },
            { label: 'GST No.', value: c.GSTNo }
        ]);
        setDropdownOpen(false);
        setClientError(false);
    };

    // ─── dropdownField for Autocomplete ───────────────────────────────────
    const dropdownField = (label, options, value, setValue) => (
        <Grid item xs={12} sm={8} md={12}>
            <Autocomplete
                fullWidth
                options={options}
                getOptionLabel={opt => opt?.label || ''}
                value={value}
                onChange={(_, v) => setValue(v)}
                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                disabled={!isEditable}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        size="small"
                        InputLabelProps={{ shrink: Boolean(value) }}
                        sx={{
                            '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                        }}
                    />
                )}
            />
        </Grid>
    );

    // ─── Next button ─────────────────────────────────────────────────────
    const handleNext = () => {
        if (!companyName || !quotationNumber) {
            setError('Party & Inquiry No. are required.');
            return;
        }
        if ((mode === 'add' || mode === 'ref') && !selectedSeries) {
            setSeriesError(true);
            setError('Series is required.');
            return;
        }
        if (!selectedClientId) {
            setClientError(true);
            return;
        }
        setError('');

        const payload = {
            clientId: selectedClientId,
            bookMastId: selectedSeries?.id,   // ✅ ADD THIS
            selectedSeries: selectedSeries,
            companyName,
            quotationNumber,
            SODate: qoutationDate ? qoutationDate.format('YYYY-MM-DD') : null,
            referenceNumber,
            referenceDate: referenceDate && referenceDate.isValid() ? referenceDate.format('YYYY-MM-DD') : null,
            CurrencyId: selectedCurrency?.id || null,
            exchangeRate: exchangeRate ? Number(exchangeRate) : null,
            kindAttend: kindAttend || null,
            remarks: remark || null,
            project: project || null,
            agentName: agentName || null,
            agentCommission: agentCommission ? Number(agentCommission) : null,
            details: details.reduce((acc, curr) => {
                acc[curr.label] = curr.value;
                return acc;
            }, {}),
            qoutId,
            transactionType,
            poNumber: poNumber || null,
            poDate:
                poDate && poDate.isValid()
                    ? poDate.format('YYYY-MM-DD')
                    : null,
            TermsType: selectedTerms?.label || null,
        };
        console.log('ClientDetails onNext payload:', payload);
        onNext(payload);
    };

    // allow editing only in 'add', 'edit', or 'ref' modes
    const isEditable = mode === 'add' || mode === 'edit' || mode === 'ref';

    return (
        <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden' }}>
            <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
                <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>

                    {/* Party dropdown */}
                    <Box
                        ref={partyDropdownRef}
                        tabIndex={-1}
                        sx={{ position: 'relative', flex: '1 1 40%' }}
                        onBlur={e => {
                            if (!partyDropdownRef.current.contains(e.relatedTarget)) {
                                setDropdownOpen(false);
                            }
                        }}
                    >
                        <TextField
                            autoFocus={mode === 'add'}
                            disabled={!isEditable || disablePartyName}
                            fullWidth
                            size="small"
                            label="Party Name"
                            error={clientError}
                            variant="outlined"
                            value={toProperCase(companyName)}
                            required
                            InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }}
                            sx={{
                                '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' },
                                '& .MuiOutlinedInput-input': { padding: '0 12px' }
                            }}
                            onChange={e => {
                                setCompanyName(toProperCase(e.target.value));
                                setDropdownOpen(true);
                                setSelectedClientId(null);
                                setClientError(false);
                                setSelectedGSTNum("");
                                setTouchedTxnType(false);
                                setHasClientChanged(true);
                            }}
                            onBlur={() => {
                                if (companyName && !selectedClientId) {
                                    setClientError(true);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (!dropdownOpen || searchResults.length === 0) return;
                                if (e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
                                } else if (e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                                } else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const selected = searchResults[highlightedIndex];
                                    if (selected) {
                                        onSelectResult(selected);
                                        setCompanyName(toProperCase(selected.FirmName));
                                        setClientError(false);
                                        setDropdownOpen(false);
                                    }
                                } else if (e.key === 'Escape') {
                                    setDropdownOpen(false);
                                }
                            }}
                            helperText={
                                clientError ? "Client does not exist. Please add new client or select from the List" : ""
                            }
                        />
                        {/* {dropdownOpen && (
                            <TableContainer
                                component={Paper}
                                elevation={0}
                                sx={{ mt: 1, maxHeight: 240, position: 'absolute', width: '120%', zIndex: 10, border: 'none', overflow: 'auto', border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1 }}
                            >
                                <Table
                                    size="small"
                                    sx={{
                                        borderCollapse: 'separate',
                                        borderSpacing: 0,
                                        tableLayout: 'fixed',              // force cells to obey widths
                                        '& thead th': {
                                            backgroundColor: '#1877F2',
                                            color: '#fff',
                                            fontWeight: 600,
                                            fontSize: '0.75rem',
                                            border: 'none'
                                        },
                                        '& th, & td': {                    // reduce padding between columns
                                            padding: '4px 6px',              // smaller vertical & horizontal padding
                                            fontSize: '0.75rem',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        },
                                        // option: collapse borders so there is no extra gap
                                        '& .MuiTableCell-root': {
                                            borderRight: '0px'               // remove right cell border if any
                                        }
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: '30%', maxWidth: 200 }}>Company</TableCell>
                                            <TableCell sx={{ width: '15%', maxWidth: 120 }}>GST No</TableCell>
                                            <TableCell sx={{ width: '20%', maxWidth: 140 }}>Contact</TableCell>
                                            <TableCell sx={{ width: '20%', maxWidth: 120 }}>Mobile</TableCell>
                                            <TableCell sx={{ width: '15%', maxWidth: 100 }}>City</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ '& > tr:last-of-type': { borderBottom: '1px solid rgba(0,0,0,0.12)' } }}>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <TableRow
                                                    key={i}
                                                    hover
                                                    onMouseDown={() => onSelectResult(r)}
                                                    sx={{ cursor: 'pointer', backgroundColor: i % 2 === 0 ? '#fff' : 'rgba(227, 242, 253, 1)', border: 'none' }}
                                                >
                                                    <TableCell sx={{ width: '30%', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.FirmName}</TableCell>
                                                    <TableCell sx={{ width: '15%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.GSTNo}</TableCell>
                                                    <TableCell sx={{ width: '20%', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.ContactPerson}</TableCell>
                                                    <TableCell sx={{ width: '20%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.MobileNo}</TableCell>
                                                    <TableCell sx={{ width: '15%', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.City}</TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center">No Data Available</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    <TableFooter sx={{ borderTop: '1px solid rgba(0,0,0,0.12)' }}>
                                        <TableRow
                                            hover
                                            sx={{ cursor: 'pointer', backgroundColor: '#fff' }}
                                            onMouseDown={() => setOpenClientPopup(true)}
                                        >
                                            <TableCell colSpan={5} sx={{ textAlign: 'center', color: 'primary.main' }}>
                                                ➕ Add New Client
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        )} */}
                        {dropdownOpen && companyName && (
                            <Paper
                                elevation={0}
                                sx={{
                                    mt: 1,
                                    position: 'absolute',
                                    width: { xs: '100%', lg: '800px' },
                                    zIndex: 10,
                                    border: '1px solid rgba(0,0,0,0.2)',
                                    borderRadius: 1,
                                    maxHeight: 240,
                                    overflowY: 'auto'
                                }}
                            >
                                {isSmallScreen ? (
                                    /* ===================== CARD VIEW (SM / XS) ===================== */
                                    <>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <Box
                                                    key={i}
                                                    sx={{
                                                        p: 1.2,
                                                        borderBottom: `1px solid ${themeColors.neutral.border}`,
                                                        cursor: 'pointer',
                                                        backgroundColor: i === highlightedIndex ? 'action.selected' : 'transparent'
                                                    }}
                                                    onMouseEnter={() => setHighlightedIndex(i)}
                                                    onMouseDown={() => {
                                                        onSelectResult(r);
                                                        // setSelectedClientId(r.ClientId);
                                                        // setSelectedGSTNum(r.GSTNo);
                                                        setCompanyName(toProperCase(r.FirmName));
                                                        setClientError(false);
                                                        setDropdownOpen(false);
                                                    }}
                                                >
                                                    <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                                                        {toProperCase(r.FirmName)}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                        GST: {r.GSTNo || '-'}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem' }}>
                                                        {toProperCase(r.ContactPerson) || '-'} • {r.MobileNo || '-'}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                        {toProperCase(r.City) || '-'}
                                                    </Box>
                                                </Box>
                                            ))
                                        ) : (
                                            <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
                                                Client not found
                                            </Box>
                                        )}

                                        {/* Sticky Add New Client */}
                                        <Box
                                            sx={{
                                                position: 'sticky',
                                                bottom: 0,
                                                backgroundColor: themeColors.neutral.surface,
                                                textAlign: 'center',
                                                p: 1,
                                                fontWeight: 600,
                                                color: 'primary.main',
                                                cursor: 'pointer',
                                                boxShadow: '0 -2px 6px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseDown={() => setOpenClientPopup(true)}
                                        >
                                            ➕ Add New Client
                                        </Box>
                                    </>
                                ) : (
                                    /* ===================== TABLE VIEW (MD / LG) ===================== */
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
                                                    <TableCell
                                                        key={h}
                                                        sx={{
                                                            backgroundColor: themeColors.neutral.line,
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1
                                                        }}
                                                    >
                                                        {h}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {searchResults.length > 0 ? (
                                                searchResults.map((r, i) => (
                                                    <TableRow
                                                        key={i}
                                                        hover
                                                        selected={i === highlightedIndex}
                                                        sx={{ cursor: 'pointer' }}
                                                        onMouseEnter={() => setHighlightedIndex(i)}
                                                        onMouseDown={() => {
                                                            onSelectResult(r);
                                                            setCompanyName(toProperCase(r.FirmName));
                                                            // setSelectedGSTNum(r.GSTNo);
                                                            setClientError(false);
                                                            setDropdownOpen(false);
                                                        }}
                                                    >
                                                        <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                                        <TableCell>{r.GSTNo}</TableCell>
                                                        <TableCell>{toProperCase(r.ContactPerson)}</TableCell>
                                                        <TableCell>{r.MobileNo}</TableCell>
                                                        <TableCell>{toProperCase(r.City)}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
                                                        Client not found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <TableFooter
                                            sx={{
                                                position: 'sticky',
                                                bottom: 0,
                                                backgroundColor: themeColors.neutral.surface
                                            }}
                                        >
                                            <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
                                                <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
                                                    ➕ Add New Client
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                )}
                            </Paper>
                        )}
                    </Box>

                    {/* Details display */}
                    <Grid item xs={12} md={4} pt={2}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Address"
                            variant="outlined"
                            disabled
                            value={
                                Array.isArray(details)
                                    ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', '))
                                    : ''
                            }
                            multiline
                            rows={3}
                            InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }}
                            sx={{
                                '& .MuiOutlinedInput-root': { display: 'flex', alignItems: 'center' },
                                '& .MuiOutlinedInput-input': { padding: '0 12px' }
                            }}
                        />
                    </Grid>

                    {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Kind Attend"
                                value={kindAttend}
                                onChange={e => setKindAttend(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(kindAttend) }}
                                disabled={!isEditable}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                }}
                            />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Project"
                                value={project}
                                onChange={e => setProject(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(project) }}
                                disabled={!isEditable}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                }}
                            />
                        </Box>
                    </Box> */}

                    <Box sx={{ mt: 2 }}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Remark"
                            disabled={!isEditable}
                            multiline
                            minRows={1}
                            maxRows={6}
                            value={remark}
                            InputLabelProps={{ shrink: Boolean(remark) }}
                            inputProps={{ maxLength: 250 }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 250) setRemark(val);
                                else setRemark(val.slice(0, 250));
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' }
                            }}
                        />
                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
                            {remark.length}/250
                        </Typography>
                    </Box>

                    <Box display="flex" justifyContent="flex-start">
                        <Box sx={{ width: '20%', mt: "-8px" }}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={termsOptions}
                                getOptionLabel={(opt) => opt?.label || ''}
                                value={selectedTerms}
                                onChange={(_, v) => setSelectedTerms(v)}
                                inputValue={termsInputValue}
                                onInputChange={(_, newInputValue) => setTermsInputValue(newInputValue)}
                                noOptionsText="Not Found"
                                isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
                                // disabled={!isEditable}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Terms"
                                        size="small"
                                        InputLabelProps={{ shrink: Boolean(selectedTerms || termsInputValue) }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                height: 38,
                                                display: 'flex',
                                                alignItems: 'center'
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                fontSize: '0.875rem',
                                                padding: '0 12px'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
                    <Box display="flex" gap={1} flex="1 1 40%">
                        {(mode === 'add' || mode === 'ref') && (
                            <Box sx={{ flex: '1 1 33.33%' }}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    options={seriesOptions}
                                    getOptionLabel={opt => opt?.label || ''}
                                    value={selectedSeries}
                                    onChange={(_, v) => {
                                        setSelectedSeries(v);
                                        setSeriesError(false);
                                    }}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Select Series"
                                            required
                                            error={seriesError}
                                            helperText={seriesError ? "Please select a series" : ""}
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                        />
                                    )}
                                />
                            </Box>
                        )}
                        <Box sx={{ flex: '1 1 33.33%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Challan No."
                                variant="outlined"
                                value={quotationNumber}
                                disabled
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { padding: '0 12px' }
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: '1 1 33.33%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Challan Date"
                                    value={qoutationDate}
                                    onChange={setqoutationDate}
                                    minDate={dayjs(startDate)}
                                    maxDate={dayjs(endDate)}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                        '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },

                                    }}
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            variant: "outlined",
                                            InputLabelProps: { shrink: true },

                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>


                    </Box>

                    {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}> */}
                    {/* <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                label="Ref. No."
                                value={referenceNumber}
                                onChange={e => setReferenceNumber(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(referenceNumber) }}
                                disabled={!isEditable}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                                }}
                            />
                        </Box> */}

                    {/* <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Ref. Date"
                                    value={referenceDate}
                                    onChange={(newValue) => setReferenceDate(newValue)}
                                    disabled={!isEditable}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                        '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                                    }}
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            variant: "outlined",
                                            InputLabelProps: { shrink: Boolean(referenceDate) },

                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Box> */}
                    {/* </Box> */}

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2} mb={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="PO No."
                                value={poNumber}
                                onChange={(e) => setPoNumber(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(poNumber) }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: 38,
                                        display: 'flex',
                                        alignItems: 'center'
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        fontSize: '0.875rem',
                                        padding: '0 12px'
                                    }
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="PO Date"
                                    value={poDate}
                                    onChange={(newValue) => setPoDate(newValue)}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: '100%', // ADD THIS
                                        '& .MuiOutlinedInput-root': {
                                            height: 38,
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            fontSize: '0.875rem',
                                            padding: '0 12px'
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true, // ALSO ADD THIS
                                            size: "small",
                                            variant: "outlined",
                                            InputLabelProps: {
                                                shrink: Boolean(poDate)
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" flexDirection={{ xs: 'column', md: 'row' }}>
                        <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
                            {showCurrency && (
                                <>
                                    <Box sx={{ flex: '0 0 50%' }}>
                                        {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)}
                                    </Box>
                                    <Box sx={{ flex: '0 0 47%' }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            type="number"
                                            variant="outlined"
                                            label="Ex Rate"
                                            value={exchangeRate}
                                            InputLabelProps={{ shrink: Boolean(exchangeRate) }}
                                            disabled={!isEditable}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                    setExchangeRate(value);
                                                }
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                                '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                                            }}
                                        />
                                    </Box>
                                </>
                            )}
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <FormControl fullWidth size="small" required sx={{
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            }} error={touchedTxnType && !transactionType} >
                                <InputLabel>Transaction Type</InputLabel>
                                <Select
                                    value={transactionType}
                                    label="Transaction Type"
                                    onChange={(e) => {
                                        setTransactionType(e.target.value);
                                        setTouchedTxnType(true);
                                    }}
                                    onBlur={() => setTouchedTxnType(true)}
                                    sx={{ height: 38 }}
                                    required
                                >
                                    <MenuItem value="Regular">Regular</MenuItem>
                                    <MenuItem value="Unregistered Persons">Unregistered Persons</MenuItem>
                                    <MenuItem value="SEZ Exempted">SEZ Exempted</MenuItem>
                                    <MenuItem value="SEZ Tax Pay">SEZ Tax Pay</MenuItem>
                                    <MenuItem value="Export With Tax Pay">Export With Tax Pay</MenuItem>
                                    <MenuItem value="Export Without Tax Pay">Export Without Tax Pay</MenuItem>
                                    <MenuItem value="Exempted Supplies">Exempted Supplies</MenuItem>
                                    <MenuItem value="Nil Rate Supplies">Nil Rate Supplies</MenuItem>
                                    <MenuItem value="Non GST Supplies">Non GST Supplies</MenuItem>
                                    <MenuItem value="Composite Supplier">Composite Supplier</MenuItem>
                                    <MenuItem value="UIN holders">UIN holders</MenuItem>
                                </Select>
                            </FormControl>

                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                label="Agent Name"
                                value={toProperCase(agentName)}
                                onChange={e => setAgentName(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(agentName) }}
                                variant="outlined"
                                size="small"
                                disabled={!isEditable}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                label="Agent Commission (%)"
                                value={agentCommission}
                                InputLabelProps={{ shrink: Boolean(agentCommission) }}
                                variant="outlined"
                                size="small"
                                type="number"
                                disabled={!isEditable}
                                onChange={e => {
                                    const v = e.target.value;
                                    if (v === '') {
                                        setAgentCommission('');
                                        return;
                                    }
                                    const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
                                    if (re.test(v)) {
                                        setAgentCommission(v);
                                    }
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                                }}
                            />
                        </Box>
                    </Box>


                </Box>
            </Box>

            {!!error && (<Typography color="error" mt={2}> {error} </Typography>)}

            <Box mt={4} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleNext} disabled={!selectedClientId || !isTransactionTypeValid}>Next</Button>
            </Box>

            {/* Popups */}
            <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                setOpenClientPopup(false);
            }}
                PaperProps={{
                    sx: {
                        width: { xs: "95%", },
                        m: { xs: 0 }
                    }
                }}

            >
                <DialogContent sx={{ p: { xs: 0 } }}>
                    <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
                <DialogContent>
                    <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
                <DialogContent>
                    <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
                <DialogContent>
                    <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
                <DialogContent>
                    <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
                <DialogContent>
                    <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
}